import dynamic from 'next/dynamic'
import { usePagePreview, PageTab } from '~/context/page-preview'

const PreviewPlaceholder = dynamic(import('../../../preview-placeholder'), {
  ssr: false,
})

export const PreviewStory = () => {
  const context = usePagePreview()

  if (!context) {
    return null
  }

  return (
    <PreviewPlaceholder
      onClick={() => context.setTab(PageTab.story)}
      height={120}
      marginBottom={20}
    >
      Write Your Story
    </PreviewPlaceholder>
  )
}
